import Globals from "./globals.js";

// color ANSI escape codes:
let Reset    = "\x1b[0m",
    Bright   = "\x1b[1m",
    Dim      = "\x1b[2m",
    Underscore="\x1b[4m",
    Blink    = "\x1b[5m",
    Reverse  = "\x1b[7m",
    Hidden   = "\x1b[8m",

    FgBlack  = "\x1b[30m",
    FgRed    = "\x1b[31m",
    FgGreen  = "\x1b[32m",
    FgYellow = "\x1b[33m",
    FgBlue   = "\x1b[34m",
    FgMagenta= "\x1b[35m",
    FgCyan   = "\x1b[36m",
    FgWhite  = "\x1b[37m",

    BgBlack  = "\x1b[40m",
    BgRed    = "\x1b[41m",
    BgGreen  = "\x1b[42m",
    BgYellow = "\x1b[43m",
    BgBlue   = "\x1b[44m",
    BgMagenta= "\x1b[45m",
    BgCyan   = "\x1b[46m",
    BgWhite  = "\x1b[47m"
/**
 * Debug functions used as a filtered console.log
 * usage: LOG.for("name") && LOG.print(value1, value2, etc.)
 * Copied from cabrihtml5/src
 */
export const LOG = {
    name: undefined,
    startTime: 0,           // in ms
    timeCabriStarted:0,     // wil be =now()  expressed in ms since 1970-01-01
    previousTime: 0,        // in ms
    //tabs: "",             // to put tabs in front of console.log outputs...
    // replaced by console.group(), console.end()
    cabriDebug: "Cabri Debug ",             // don't miss a ' ' at the end !
    /**
     * Filter function used prior to a CabriLog.log call
     * Matches Globals.Developer value ("all" can also be used and checks only Globals.Developer existence)
     * @param   {string} name - Name used to filter debug logging
     * @returns {boolean} Say if the given name is equal to string - or in array - Globals.Developer
     */
    for(name) {
        if (typeof Globals !== "object" || !Globals.Developer)
            return false;
        this.name = name;
        if (name === "all")
            return true;

        const dev = Globals.Developer;
        if (dev instanceof Array)
            return dev.includes(name);
        else if (dev === "all")
            return true;
        else
            return dev === name;
    },

    /**
     * Outputs given arguments with the filter name a prefix
     *
     * @param args - A list of arguments passed to console.log
     */
    print(func, ...args) {
        // the test on this.name ensures that filter is called prior to log
        if (this.name) {
            func((Globals.LogPrefix ? "["+Globals.LogPrefix+"] " : "") + this.name + '>', ...args);
            this.name = undefined;
        }
    },
    info(...args) {
        this.print(console.log, ...args);
    },
    warn(...args) {
        this.print(console.warn, ...args);
        this.print(console.error, ...args);
    },
    error(...args) {
    },

    setStartTime: function() {
        this.startTime = new Date().getTime();
    },
    time(...args) {
        this.print(console.log, "@", new Date().getTime() - this.startTime, "ms| ", ...args);
    },
}  // ends export const LOG

export const Cabrilog = {
    log: function(user, text, timed = false, style = "") {
// user contains a devkey to be one the Globals.Developer[], possible "all"
        // and addition information as
        // -->  to indent using console.group()
        // <--  to unindent using console .groupEnd()
        // a color currently "red" or "blue", ...
// text is a string to be displayed (possibly as console.group(text) if -->
// timed a boolean or a value (<=1 time elapsed since start, >1, time since last call)

// checking if user (without initial '\n's) is among the current members of  Globals.Developer[]
// FRONT '\n's
        let spaces = ""
        let cnt = 0
        while (user[cnt++] === '\n')
            spaces += '\n'
        if (cnt>1)
            user = user.substring(cnt-1);
// "-->" or "<--"
        let indent = 0
        if (1+user.indexOf("->")) {                // >1 as soon "-->" is part of user
            //LOG.tabs += "    ";
            indent = 1
            user = user.replace(/ *-*> */, "");      // suppress --> and additional ' '
        }
        else if (1+user.indexOf("<-")) {
            indent = -1
            user = user.replace(/ *<-* */,"");
        }
//COLORS
        let color= ""
        if (user.includes("red")) {
            color= FgRed
            user = user.replace(/ *red */,"");
        }
        if (user.includes("blue")) {
            color= FgCyan
            user = user.replace(/ *blue */,"");
        }

// checking if user is active in string (o (string array) Global.Developer
        let dev = Globals.Developer
        if (dev instanceof Array ? !dev.includes(user) : dev !== user)
            if (user !== "all" && dev !== "any" )
                return
        //if (!LOG.for( user))
        //    return

//TIME
        let elapsedTime, timeStr = ""
        if (timed) {
            let previousTime = timed === 1 ?  LOG.timeCabriStarted : LOG.previousTime
            let now = Date.now()
            elapsedTime = now- LOG.previousTime
            LOG.previousTime = now
            let timeUnit = " ms"
            if (elapsedTime>=1000) {
                elapsedTime /= 1000
                timeUnit = " s"
            }
            timeStr = " ------- "+ (timed === 1 ? "elapsed time since launch: " : "additional time: ") + elapsedTime + timeUnit
        }

//STYLE

        // ANSI Esc code Dim seems without effect
        let output = spaces+LOG.cabriDebug+color+user +'> '+ text + FgBlack + timeStr

        if (indent === 0) {
//REGULAR CASE
            console.log(output)
            return;
        }
        if (indent === 1) {
            console.group(output)
            return;
        }
        else if (indent === -1) {
            console.groupEnd()
            console.log(output)
            return;
        }

        if (user.includes("red"))
            spaces+= FgRed
        else if (user.includes("blue"))
            spaces+= FgCyan


        /*console.log("colors: \n" +  "\x1b[40m40m" +"\x1b[41m41m"+ "\x1b[42m42m" + "\x1b[43m43m" + "\x1b[44m44m" + "\x1b[45m45m" +
         "\x1b[46m46m"+ "\x1b[47m47m" + "\n" +         "\x1b[0m" +
         "\x1b[30m30m" +"\x1b[31m31m"+ "\x1b[32m32m" + "\x1b[33m33m" + "\x1b[34m34m" + "\x1b[35m35m" +
         "\x1b[36m36m"+ "\x1b[37m37m" + "\n" +
         "\x1b[0m0m"+ "\x1b[1m1m"+"\x1b[2m2m"   +   "\x1b[4m4m"+"\x1b[5m5m"    +  "\x1b[7m7m" + "\x1b[8m8m")*/
//console.log(BgRed + "BackGround red" + Reset + FgYellow + "ForeGround Yellow")

        /*console.log("flat")
         console.group(1)
         console.log("1")
         console.group(2)
         console.log("2")
         console.group(3)
         console.log("3")
         console.groupEnd(4)
         console.log("2")
         console.log("2")
         console.group(5)
         console.log("3")
         console.groupEnd(6)
         console.log("2")
         console.groupEnd(7)
         console.groupEnd(8)
         console.log("flat")*/

    },    // ends log(...)

    log_Value: function(key, value, user) {      // key is an ordinary string
        if (LOG.for(user))
            console.log((Globals.LogPrefix ? "["+Globals.LogPrefix+"] " : "") + user + '>',
                key,"=",value)
    },

    logValue: function(key, value, user) {      // key is an ordinary string
        if (LOG.for(user))
            console.log((Globals.LogPrefix ? "["+Globals.LogPrefix+"] " : "") + user + '>',
                key,"=",value)
    }
} // export const Cabrilog
